export interface ScrollBoxConfig {
    viewport: HTMLElement;
    content: HTMLElement;
}

export class ScrollBox {
    private readonly elements: {
        viewport: HTMLElement;
        content: HTMLElement;
    };
    protected scrollerHeightMin: number = 25;
    protected pressed: boolean = false;
    protected viewportHeight: number;
    protected contentHeight: number;
    protected max: number;
    protected ratio: number;
    protected scroller: HTMLElement;
    protected scrollerHeight: number;
    protected start: number;


    constructor({viewport, content}: ScrollBoxConfig) {
        this.elements = {viewport, content};
        this.init();
    }

    protected createScrollbar(): void {
        const
            {viewport, content} = this.elements,
            scrollbar = document.createElement('div'),
            scroller = document.createElement('div');

        scrollbar.className = 'scrollbox__scrollbar';
        scroller.className = 'scrollbox__scroller';

        scrollbar.appendChild(scroller);
        viewport.appendChild(scrollbar);

        this.scroller = viewport.querySelector('.scrollbox__scroller');
        this.scrollerHeight = parseInt(`${this.ratio * this.viewportHeight}`);
        this.scrollerHeight = (this.scrollerHeight <= this.scrollerHeightMin)
            ? this.scrollerHeightMin
            : this.scrollerHeight;
        this.scroller.style.height = this.scrollerHeight + `px`;
    }

    protected drop(evt: MouseEvent): void {
        if (this.pressed === false) return;
        evt.preventDefault();

        let shiftScroller = this.start - evt.clientY;
        this.scroller.style.top = (this.scroller.offsetTop - shiftScroller) + 'px';

        let shiftContent = this.scroller.offsetTop / this.ratio;
        const totalheightScroller = this.scroller.offsetHeight + this.scroller.offsetTop;
        const maxOffsetScroller = this.viewportHeight - this.scroller.offsetHeight;

        if (this.scroller.offsetTop < 0) this.scroller.style.top = `0px`;
        if (totalheightScroller >= this.viewportHeight) this.scroller.style.top = maxOffsetScroller + `px`;

        this.elements.content.scrollTo(0, shiftContent);
        this.start = evt.clientY;
    }

    protected bind(): void {
        const {viewport, content} = this.elements;

        content.addEventListener('scroll', () => {
            this.scroller.style.top = (content.scrollTop * this.ratio) + `px`;
        });
        this.scroller.addEventListener('mousedown', e => {
            this.start = e.clientY;
            this.pressed = true;
        });
        document.addEventListener('mousemove', this.drop.bind(this));
        document.addEventListener('mouseup', () => this.pressed = false);
    }

    protected init(): void {
        const {viewport, content} = this.elements;
        this.viewportHeight = viewport.offsetHeight;
        this.contentHeight = content.scrollHeight;

        if (this.viewportHeight >= this.contentHeight) return;

        this.max = viewport.clientHeight - this.contentHeight;
        this.ratio = this.viewportHeight / this.contentHeight;
        this.createScrollbar();
        this.bind();
    }
}